import React from "react";

const CustomerConfirm = ({ open, handleClose, Module }) => {
  const handleCancelPopupApi = (Value) => {
    handleClose(Value);
  };

  return (
    <div
      className={`modal fade ${open ? "show d-block" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          {/* Modal Header */}
          <div className="modal-header">
            <h5 className="modal-title">Confirmation</h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleClose}
            ></button>
          </div>

          {/* Modal Body */}
          <div className="modal-body text-center">
            <p>Are you sure you want to clear this {Module}.</p>
          </div>

          {/* Modal Footer */}
          <div className="modal-footer justify-content-center">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleCancelPopupApi("Ok")}
            >
              OK
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => handleCancelPopupApi("Cancel")}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerConfirm;
